export default __webpack_public_path__ + "static/media/instructor-2.4c0aa63d.webp";